export const parseTimestamp = (ts: any): Date | undefined => {
  if (!ts) {
    return;
  }
  if ("toDate" in ts) {
    return ts.toDate();
  }
  return;
};
